var React = require('react');

function SocialX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.3997 11.1376L26.7869 0H24.2479L15.2736 9.62355L8.08624 0H0.0936982L10.8325 14.3814L0 26H2.54312L11.9635 15.8947L19.51 26H27.4983L16.3997 11.1376ZM13.2546 14.5141L12.1235 13L3.80265 1.85821H7.15506L13.9859 11.005L15.1169 12.5149L23.7944 24.1376H20.442L13.2554 14.5141H13.2546Z","fill":"white"}));
}

SocialX.defaultProps = {"width":"28","height":"26","viewBox":"0 0 28 26","fill":"none"};

module.exports = SocialX;

SocialX.default = SocialX;
